module.exports = __webpack_public_path__ + "img/icon_exchange_3people.8f5867cd.png";